import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AUTH_ROUTES } from "./consts";
import { User, Lock, ArrowRight, AlertCircle, KeyRound } from "lucide-react";

const Login = ({ onLoginSuccess }) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (auth === "1") {
      navigate("/tickets", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(AUTH_ROUTES.LOGIN, {
        username,
        password,
      });

      const code = response.data?.code;
      const msg = response.data?.message || response.data?.msg || "Giriş işlemi tamamlandı.";

      console.log(response);
      if (code === 100) {
        localStorage.setItem("auth", "1");
        if (response.data?.token) {
          localStorage.setItem("token", response.data.token);
        }

        if (onLoginSuccess) {
          onLoginSuccess("1");
        }

        navigate("/tickets", { replace: true });
      } else {
        throw new Error(msg);
      }
    } catch (err) {
      const msg =
        err.response?.data?.msg ||
        err.message ||
        "Giriş başarısız. Bilgilerinizi kontrol edin.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 font-sans text-gray-800">
      <div className="w-full max-w-sm">
        {/* Logo Alanı */}
        <div className="flex flex-col items-center justify-center mb-10">
          <img src="/macroturk.svg" alt="Macroturk Logo" className="h-8" />
          <p className="text-sm text-gray-400 mt-3 font-bold flex items-center gap-2">
            Etkinlik Bilet Kontrol Uygulaması <span><img src="/ticket.svg" className="w-6 h-6 opacity-60" /></span>
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-gray-300 overflow-hidden">
          <div className="px-6 pt-8 pb-6 text-center">
            <h1 className="text-2xl font-bold text-gray-600 tracking-tight mb-2">
              Hoş Geldiniz
            </h1>
            <p className="text-sm text-gray-500">
              Yönetici bilgilerinizle giriş yapın.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="px-8 pb-8 space-y-5">
            {error && (
              <div className="rounded-2xl border border-red-100 bg-red-50 p-4 flex gap-3 items-start">
                <AlertCircle className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />
                <p className="text-sm text-red-600 font-medium">{error}</p>
              </div>
            )}

            <div className="space-y-2">
              <label className="block text-xs font-bold uppercase tracking-wider text-gray-400 ml-1">
                Kullanıcı Adı
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <User className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand transition-all font-medium"
                  placeholder="kullaniciadi"
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-xs font-bold uppercase tracking-wider text-gray-400 ml-1">
                Şifre
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <KeyRound className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand transition-all font-medium"
                  placeholder="••••••••"
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-brand text-white py-4 rounded-2xl font-bold shadow-lg shadow-brand/40 hover:bg-brand/90 active:scale-[0.98] transition-all disabled:opacity-70 disabled:cursor-not-allowed mt-4"
            >
              {loading ? (
                "Giriş Yapılıyor..."
              ) : (
                <>
                  Giriş Yap
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
